import React from 'react'
let Context=React.createContext("")
export default Context